// import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },

    /*component: () => {
      if (('; '+document.cookie).split(`; userr=`).pop().split(';')[0] == 0) {
        return import('./views/processing');
      } else {
        return import('./views/manager/assignmentsList');
      }
    }*/

    

  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        //redirecting depending on cookie
        const token = ('; '+document.cookie).split(`; token=`).pop().split(';')[0];
          // If the user is already logged in
          if (token && routeTo.query.redirectFrom!="/logout") {
            // Redirect to the home page instead
            next({ name: 'default' })
          } else {
            // Continue to the login page
            next()
          }

        // // If the user is already logged in
        // if (store.getters['auth/loggedIn']) {
        //   // Redirect to the home page instead
        //   next({ name: 'default' })
        // } else {
        //   // Continue to the login page
        //   next()
        // }
      },
    },
  },



]
